import { IconType } from "react-icons";
import { FaMotorcycle, FaCarSide, FaTruckPickup } from "react-icons/fa";

export interface VehicleTypeDisplay {
  label: string;
  icon: IconType;
}

/**
 * Maps backend vehicleType codes to label/icon for display.
 * Returns undefined if no vehicleType provided or unsupported.
 */
export const getVehicleTypeDisplay = (
  vehicleType?: number
): VehicleTypeDisplay | undefined => {
  if (vehicleType === 2) return { label: "2W", icon: FaMotorcycle };
  if (vehicleType === 3) return { label: "3W", icon: FaTruckPickup };
  if (vehicleType === 4) return { label: "4W", icon: FaCarSide };
  return undefined;
};
